import { useCallback, useState } from "react";
import { QueryKey, useQueryClient } from "@tanstack/react-query";
import { ProjectManagersService } from "@/modules/projects/service/projectManagers";
import { useCheckIsProjectLocked } from "./useCheckIsProjectLocked";
import { RowSelectionStore } from "@/components/data-table/context/RowSelectionContext";

export const useProjectManagersRemoveUsersForm = ({
  store,
  projectId,
  queryKey,
}: {
  store: RowSelectionStore;
  projectId: string;
  queryKey: QueryKey;
}) => {
  const queryClient = useQueryClient();
  const isProjectLocked = useCheckIsProjectLocked();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (isProjectLocked) return;

    const checkedManagerIds = Array.from(store.getSelection());

    if (checkedManagerIds.length === 0) return;

    setIsSubmitting(true);
    try {
      await ProjectManagersService.removeUsers(projectId, checkedManagerIds);
      await queryClient.invalidateQueries({ queryKey });
      store.clear();
    } finally {
      setIsSubmitting(false);
    }
  }, [projectId, queryClient, queryKey, store, isProjectLocked]);

  return {
    handleSubmit,
    isSubmitting,
  };
};
